import React, { useEffect } from 'react';
import { View, TouchableOpacity } from 'react-native';

import ColorWrapper from '@styles/colors';

import Svg from '@styles/icons/svg';

import { APP_STORE_URL, PLAY_STORE_URL } from '@v2/pages/common/constants/base.constants';

const QRCode = ({ C }) => {
  useEffect(() => {
    const getMobileOperatingSystem = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android|Android/i.test(userAgent)) {
        return 'Android';
      }

      if (
        (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ||
        (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2)
      ) {
        return 'iOS';
      }

      return 'unknown';
    };

    let os = getMobileOperatingSystem();

    switch (os) {
      case 'Android': {
        window.location.href = PLAY_STORE_URL;
        break;
      }
      case 'iOS': {
        window.location.href = APP_STORE_URL;
        break;
      }
    }
  }, []);
  return (
    <View
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: C('Background/Light/Detail'),
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      }}
    >
      <TouchableOpacity
        onPress={() => {
          window.location.href = APP_STORE_URL;
        }}
        style={{ cursor: 'pointer' }}
      >
        <View
          style={{
            transform: [
              {
                scale: 2,
              },
            ],
            marginBottom: 100,
          }}
        >
          <Svg icon="apple" width={102} height={30} color={C('Label/Light/Secondary')} />
        </View>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => {
          window.location.href = PLAY_STORE_URL;
        }}
        style={{ cursor: 'pointer' }}
      >
        <View
          style={{
            transform: [
              {
                scale: 2,
              },
            ],
            marginTop: 100,
          }}
        >
          <Svg icon="android" width={102} height={30} color={C('Label/Light/Secondary')} />
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default ColorWrapper(QRCode);
